import axios from 'axios';
let input = document.querySelectorAll('#xsrf input')[0];

const umbracoSurfaceUrl = '/umbraco/surface/';
const umbracoApiUrl = '/umbraco/api/';
const mockApiUrl = 'https://8e4bd62a-b73b-40e8-b3be-e6c2a66e8faf.mock.pstmn.io/';

const axiosSurface = axios.create(instanceParams(umbracoSurfaceUrl));
const axiosApi = axios.create(instanceParams(umbracoApiUrl));

axiosSurface.interceptors.response.use(function(response) {
  return response.data;
}, function(error) {
  console.warn('$store response error interceptor hit');
  return Promise.reject(error);
});

axiosApi.interceptors.response.use(function(response) {
  return response.data;
}, function(error) {
  console.warn('$store response error interceptor hit');
  return Promise.reject(error);
});

function instanceParams(url){
  return {
    baseURL: url,// (process.env.NODE_ENV !== 'production') ? mockApiUrl : url,
    timeout: 60000,
    headers: { 'X-XSRF-Token-App': input !== undefined ? input.value : 'none' }
  }
}

export { axiosSurface as default, axiosApi };
